import { Controller } from "react-hook-form";
import { FormGroup, Label } from "reactstrap";

const ControlledSelect = ({ id, control, options, label, children, required }) => {
  return (
    <FormGroup>
      <Label htmlFor={id}>
        {label}
        {required ? " *" : ""}
      </Label>
      <Controller
        name={id}
        control={control}
        render={({ field: { value, onChange } }) =>
          children({ value, onChange, options })
        }
      />
    </FormGroup>
  );
};

export default ControlledSelect;
